module.exports = __webpack_public_path__ + "static/media/lions-live-section.9381846e.png";